import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/primitives';
import { cn } from '@/lib/utils';

export function PaginationButtons({
  page,
  pageCount,
  onPrev,
  onNext,
  className,
}: {
  page: number;
  pageCount: number;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2 text-xs', className)}>
      <Button
        variant="ghost"
        size="sm"
        disabled={page <= 1}
        aria-label="Página anterior"
        onClick={onPrev}
      >
        <ChevronLeft className="size-3.5" aria-hidden />
      </Button>
      <span className="text-[var(--color-muted)]">
        {page} de {pageCount}
      </span>
      <Button
        variant="ghost"
        size="sm"
        disabled={page >= pageCount}
        aria-label="Próxima página"
        onClick={onNext}
      >
        <ChevronRight className="size-3.5" aria-hidden />
      </Button>
    </div>
  );
}
